function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "111.7%",
  height: "111.7%",
  x: "-5.8%",
  y: "-4.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "d",
  width: "117.5%",
  height: "117.5%",
  x: "-8.8%",
  y: "-6.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("circle", {
  id: "b",
  cx: 16,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M12.116 13.404L16 9.52l3.886 3.886 2.26-2.26L16 5l-6.144 6.144 2.26 2.26zM6 15l2.26-2.26L10.52 15l-2.26 2.26L6 15zm6.116 1.596L16 20.48l3.886-3.886 2.26 2.259L16 25l-6.144-6.144-.003-.003 2.263-2.257zM21.48 15l2.26-2.26L26 15l-2.26 2.26L21.48 15zm-3.188-.002h.002V15L16 17.294l-2.291-2.29-.004-.004.004-.003.401-.402.195-.195L16 12.706l2.293 2.293z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  fill: "#F3BA2F",
  fillRule: "evenodd",
  xlinkHref: "#b"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 15,
  r: 14.5,
  stroke: "#000",
  strokeOpacity: 0.097
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#d)",
  xlinkHref: "#e"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "evenodd",
  xlinkHref: "#e"
});

function SvgBscTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#b"
  }), _ref5, _ref6, _ref7));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscTest);
export default __webpack_public_path__ + "static/media/bsc_test.9db5aa6c.svg";
export { ForwardRef as ReactComponent };